<template lang="pug">
d2-container
  el-form(
    :inline="true",
    :model="dataForm",
    size="mini",
    label-position="right",
    label-width="75px",
    label-suffix=":"
  )
    el-row(:span="24")
      el-col(:md="6", :sm="8")
        el-form-item(label="订单编号")
          el-input.inputWidth(
            v-model="dataForm.orderNumber",
            placeholder="订单编号",
            clearable=""
          )
      el-col(:md="6", :sm="8")
        el-form-item(label="比赛ID")
          el-input.inputWidth(
            v-model="dataForm.busId",
            placeholder="比赛ID",
            clearable=""
          )
      el-col(:md="6", :sm="8")
        el-form-item(label="账号", label-position="right")
          el-input.inputWidth(
            v-model="dataForm.account",
            placeholder="账号",
            clearable=""
          )
      el-col(:md="6", :sm="8")
        el-form-item(label="姓名", label-position="right")
          el-input.inputWidth(
            v-model="dataForm.orderUserName",
            placeholder="姓名",
            clearable=""
          )
    el-row(:span="24")
      el-col(:md="6", :sm="8")
        //-  el-form-item(label='主办方')
        //-     el-select.inputWidth(v-model="dataForm.orgId",placeholder="请选择" clearable)
        //-         el-option(v-for="(item,index) in sysOrgList",:key="index",:label="item.name",:value="item.orgId" )
      el-col(:md="6", :sm="8")
        el-form-item(label="订单日期")
          el-date-picker(
            style="width: 210px",
            v-model="dataForm.payTime",
            range-separator="至",
            type="daterange",
            start-placeholder="开始日期",
            end-placeholder="结束日期",
            value-format="yyyy-MM-dd"
          )
      el-col(:md="6", :sm="8")
        el-form-item(label="状态")
          el-select.inputWidth(v-model="dataForm.payStatus", clearable)
            el-option(label="未支付", value=0)
            el-option(label="支付中", value=1)
            el-option(label="支付成功", value=2)
            el-option(label="支付失败", value=3)
            el-option(label="支付已关闭", value=9)
            el-option(label="超时", value=4)
            el-option(label="申请退款", value=5)
            el-option(label="退款中", value=6)
            el-option(label="退款成功", value=7)
            el-option(label="退款失败", value=8)
            el-option(label="退款已取消", value=10)
      el-col(:md="6", :sm="8")
        el-form-item(label="比赛类型")
          el-select.inputWidth(v-model="dataForm.orderType", clearable)
            el-option(label="单项赛", value=11)
            el-option(label="团体赛", value=12)
    el-row(:span="24")
      el-col(:span="12", style="padding-bottom: 15px")
        el-button(
          @click="exportExcel()",
          type="primary",
          style="float: left",
          v-if="isAuth('ct:competitionOrder:upload')"
        ) 列表导出
      el-col(:span="12", style="padding-bottom: 15px")
        el-button(
          @click="getDataList()",
          type="primary",
          icon="el-icon-search",
          style="float: right"
        ) 查 询
      el-col(:span="24", style="padding-bottom: 15px")
        span(style="float: right; color: red") ￥{{ totalMoney }}元
        span(style="float: right") 总金额：
    el-table(
      :data="tableData",
      style="width: 100%",
      v-loading="dataListLoading",
      border
    )
      el-table-column(
        prop="orderNumber",
        header-align="center",
        align="center",
        label="订单编号"
      )
      el-table-column(
        prop="createTime",
        header-align="center",
        align="center",
        label="订单日期"
      )
      //- el-table-column(prop='orgName' header-align='center',align='center',label='主办方')
      el-table-column(
        prop="busName",
        header-align="center",
        align="center",
        label="比赛名称"
      )
      el-table-column(
        prop="busId",
        header-align="center",
        align="center",
        label="比赛ID"
      )
      el-table-column(
        prop="orderUserName",
        header-align="center",
        align="center",
        label="会员名称"
      )
      el-table-column(
        prop="account",
        header-align="center",
        align="center",
        label="会员账号",
        width="120"
      )
      el-table-column(
        prop="payAmount",
        header-align="center",
        align="center",
        label="支付金额",
        width="90"
      )
        template(slot-scope="scope")
          font(v-if="scope.row.payAmount != null")
            span ¥ {{ parseFloat(scope.row.payAmount).toFixed(2) }} 元
      //- el-table-column(
      //-   prop="refundScale",
      //-   header-align="center",
      //-   align="center",
      //-   label="退款比例",
      //-   width="90"
      //- )
      //-   template(slot-scope="scope")
      //-     font(v-if="scope.row.refundScale != null")
      //-       span {{ scope.row.refundScale }} %
      el-table-column(
        prop="refundAmount",
        header-align="center",
        align="center",
        label="退款金额",
        width="90"
      )
        template(slot-scope="scope")
          font(v-if="scope.row.refundAmount != null")
            span ¥ {{ parseFloat(scope.row.refundAmount).toFixed(2) }} 元
      el-table-column(
        prop="payStatus",
        header-align="center",
        align="center",
        label="状态"
      )
        template(slot-scope="scope")
          font(v-if="scope.row.payStatus === 0")
            span.danger
            span &nbsp; 未支付
          font(v-if="scope.row.payStatus === 1")
            span.warning
            span &nbsp; 支付中
          font(v-if="scope.row.payStatus === 2")
            span.success
            span &nbsp; 支付成功
          font(v-if="scope.row.payStatus === 3") 支付失败
          font(v-if="scope.row.payStatus === 4")
            span.warning
            span &nbsp; 超时
          font(v-if="scope.row.payStatus === 5") 申请退款
          font(v-if="scope.row.payStatus === 6")
            span.warning
            span &nbsp; 退款中
          font(v-if="scope.row.payStatus === 7")
            span.success
            span &nbsp; 退款成功
          font(v-if="scope.row.payStatus === 8") 退款失败
          font(v-if="scope.row.payStatus === 9") 支付已关闭
          font(v-if="scope.row.payStatus === 10")
            span.warning
            span &nbsp; 退款已取消
      el-table-column(
        prop="",
        header-align="center",
        align="center",
        label="操作",
        width="100"
      )
        template(slot-scope="scope")
          el-menu.menuPonit(:collapse="isCollapse")
            el-submenu(index="1")
              template(slot="title")
                i.el-icon-more(style="color: #02b90d")
              el-menu-item-group
                el-menu-item(
                  index="1-1",
                  @click="queryHandle(scope.row.id)",
                  v-if="isAuth('ct:competitionOrder:detail')"
                ) 查看

    el-pagination(
      @size-change="sizeChangeHandle",
      @current-change="currentChangeHandle",
      :current-page="pageIndex",
      :page-sizes="[10, 20, 50, 100]",
      :page-size="pageSize",
      :total="totalPage",
      layout="total, sizes, prev, pager, next, jumper"
    )
    detail(v-if="detailVisiable", ref="detail", @refreshDataList="getDataList")
</template>
<script>
import Detail from "./detail.vue";
import table from "./table.js";
import { get30DaysArray } from '@/util/dateUtils'

export default {
  name: "finance-competitionOrder-classification",
  components: {
    Detail,
  },
  data() {
    return {
      table: {
        columns: table.columns,
        data: null,
        size: "mini",
        stripe: true,
        border: true,
      },
      isCollapse: true,
      detailVisiable: false,
      dataForm: {
        orgId: null, //主办方
        orderNumber: "", //订单编号
        busId: "",
        account: "",
        orderUserName: "",
        payTime: "",
        payStatus: null,
        orderType: "11",
      },
      tableData: [],
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      sysOrgList: [],
      dataListLoading: false,
      totalMoney: undefined,
    };
  },
  mounted() {
    this.dataForm.payTime = get30DaysArray()
    this.getDataList();
    this.initOrgList();
  },
  methods: {
    // 获取数据列表
    getDataList() {
      console.log(this.dataListLoading);
      this.dataListLoading = true;
      let payStrTime = null;
      let payEndTime = null;
      if (this.dataForm.payTime !== null) {
        if (this.dataForm.payTime.length > 0) {
          payStrTime = this.dataForm.payTime[0];
          payEndTime = this.dataForm.payTime[1];
        }
      }
      this.$http({
        url: this.$http.adornUrl("/payOrder/selfList"),
        method: "POST",
        params: this.$http.adornParams({
          page: this.pageIndex,
          rows: this.pageSize,
          orgId: this.dataForm.orgId, //主办方
          orderNumber: this.dataForm.orderNumber, //订单编号
          busId: this.dataForm.busId,
          account: this.dataForm.account,
          orderUserName: this.dataForm.orderUserName,
          payStrTime: payStrTime,
          payEndTime: payEndTime,
          payStatus: this.dataForm.payStatus,
          orderType: this.dataForm.orderType , //单项赛11 团体赛12
        }),
      }).then((data) => {
        console.log(data);
        if (data && data.code === 0) {
          console.log(data.page.rows);
          this.tableData = data.page.rows;
          this.totalPage = data.page.total;
          this.totalMoney = data.total;
        } else {
          this.tableData = [];
          this.totalPage = 0;
        }
        this.dataListLoading = false;
      });
    },
    // 每页数
    sizeChangeHandle(val) {
      this.pageSize = val;
      this.pageIndex = 1;
      this.getDataList();
    },
    // 当前页
    currentChangeHandle(val) {
      this.pageIndex = val;
      this.getDataList();
    },
    initOrgList() {
      this.$http({
        url: this.$http.adornUrl("/sysOrg/list"),
        method: "get",
      }).then((data) => {
        this.sysOrgList = data && data.code === 0 ? data.list : [];
      });
    },
    queryHandle(id) {
      this.detailVisiable = true;
      this.$nextTick(() => {
        this.$refs.detail.init(id);
        this.$refs.detail.getDataList();
      });
    },
    exportExcel() {
      //导出列表
      let payStrTime = null;
      let payEndTime = null;
      if (this.dataForm.payTime !== null) {
        if (this.dataForm.payTime.length > 0) {
          payStrTime = this.dataForm.payTime[0];
          payEndTime = this.dataForm.payTime[1];
        }
      }
      this.$http({
        url: this.$http.adornUrl("/payOrder/getExportList"),
        method: "POST",
        params: this.$http.adornParams({
          orgId: this.dataForm.orgId, //主办方
          orderNumber: this.dataForm.orderNumber, //订单编号
          busId: this.dataForm.busId,
          account: this.dataForm.account,
          orderUserName: this.dataForm.orderUserName,
          payStrTime: payStrTime,
          payEndTime: payEndTime,
          payStatus: this.dataForm.payStatus,
          orderType: 1, //分级公开赛
        }),
      }).then((data) => {
        console.log(data);
        if (data && data.code === 0) {
          console.log(data.list);
          if (data.list == null || data.list.length === 0) {
            this.$message.info("没有要导出的数据!");
            return;
          }
          let exportData = data.list;
          for (let i of exportData) {
            i.payAmount = i.payAmount ? "¥" + i.payAmount + "元" : "";
            i.refundScale = i.refundScale ? i.refundScale + "%" : "";
            i.totalAmount = i.totalAmount ? "¥" + i.totalAmount + "元" : "";
            i.payStatus = {
              0: "未支付",
              1: "支付中",
              2: "支付成功",
              3: "支付失败",
              4: "超时",
              5: "申请退款",
              6: "退款中",
              7: "退款成功",
              8: "退款失败",
              9: "支付已关闭",
              10: "退款已取消",
            }[i.payStatus];
          }
          console.log("导出的订单数据：", exportData);
          this.$export
            .excel({
              columns: this.table.columns,
              data: exportData,
              title: "分级公开赛订单",
            })
            .then(() => {
              this.$message.success("导出表格成功");
            });
        }
      });
    },
  },
};
</script>
<style>
.inputWidth {
  width: 210px;
}
.el-form--inline .el-form-item {
  display: inline-block;
  margin-right: 0px;
  vertical-align: top;
}
</style>
<style >
/* 操作三点 菜单样式 */
@import "../../../css/opr3dot.css";
</style>
